(function() {
    'use strict';
    angular
        .module('quilinkApp')
        .factory('History', History);

    History.$inject = ['$resource'];

    function History ($resource) {
        var resourceUrl =  'api/history/newsfeed?sectorId';

        return $resource(resourceUrl, {id:'@id'}, {
            'newsfeed': {
                method: 'GET',
                isArray: true
            },
            'newsfeedOrganisation': {
                url: 'api/history/newsfeed/organisation/:id',
                method: 'GET',
                isArray: true
            },
            'newsfeedProfile': {
                url: 'api/history/newsfeed/profile/:id',
                method: 'GET',
                isArray: true
            },
            'resetOrganisation': {
                url: 'api/history/reset/organisation/:id',
                method: 'POST'
            },
            'resetProfile': {
                url: 'api/history/reset/profile/:id',
                method: 'POST'
            },
            'resetUser': {
                url: 'api/history/reset/user/:id',
                method: 'POST'
            },
            'get': {
                url: 'api/history/:resource/:id',
                method: 'GET',
                isArray: true
            },
            'myCredits': {
                url: '/api/history/myCredits',
                method: 'GET'
            },
            'userCredits': {
                url: '/api/history/credits/:email/email',
                method: 'GET'
            },
            'profileAdd': {
                url: '/api/history/profile',
                method: 'GET',
                isArray: true
            },
            'previousProfile': {
                url: '/api/history/profile/previous/:profileId',
                method: 'GET'
            }

            
        });
    }
})();
